module.exports = __webpack_public_path__ + "static/img/h_12@2x.aed6a2ac.png";